import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Ticker from './Ticker';
import Navbar from './Navbar';
import Hero from './Hero';
import Services from './Services';
import Process from './Process';
import Trust from './Trust';
import Locations from './Locations';
import Reviews from './Reviews';
import Footer from './Footer';
import FloatingButtons from './FloatingButtons';
import HomePickupCalculator from './HomePickupCalculator';
import { scrollToSection } from '../utils/navigation';

const Home = () => {
  const location = useLocation();

  // Handle hash navigation when component mounts or hash changes
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');
      setTimeout(() => scrollToSection(sectionId), 300);
    }
  }, [location]);

  return (
    <div className="home">
      <Ticker />
      <Navbar />
      <Hero />
      <Services />
      <HomePickupCalculator />
      <Process />
      <Trust />
      <Reviews />
      <Locations />
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Home;
